import React from 'react';
import { Alert } from 'react-bootstrap';
import MessageShower from '../peoples/editor/comments/list';
import useSubscribed from './hook';
import LoaderContainer from './LoaderContainer';

const getReqestOptions = (currentUser) => ({
  subscriber: currentUser.id,
});

function SubscribedComments() {
  const {
    items, err, loading, setErr,
    prevPageHandler, nextPageHandler, canNext, canPrev,
  } = useSubscribed({
    uri: '/api/cat/comments/',
    optionsGetter: getReqestOptions,
  });

  return (
    <div className="rounded border p-2">
      <LoaderContainer
        err={err}
        loading={loading}
        setErr={setErr}
        onPrevPage={prevPageHandler}
        onNextPage={nextPageHandler}
        canNext={canNext}
        canPrev={canPrev}
      >
        {items.length
          ? items.map((row) => (
            <MessageShower key={row.id} message={row} showPeople />
          ))
          : (
            <Alert variant="info">
              You have no subscribed messages.
            </Alert>
          )}
      </LoaderContainer>
    </div>
  );
}

export default SubscribedComments;
